import create from "zustand"

import { getBranch } from '../api/user.api'

const initailState = { Branches : null }

const User = (set, get) => ({
	...initailState,
	getBranches: async (BType, enqType, value) => {
		await getBranch().then((r) => {
		if (r.data.response_code === '01') {
			set({ Branches: r.data.branch_ids });
		} else {
			set({ Branches: null });
		}
		});
	},

	reset: () => set(() => ({ Branches: null })),
});

const UserStore = create(User);

export default UserStore